// Acciones asincronas que pueden llamar una inforrmacion

import {
  getEstanciasAlum,
  subirDocumentacion,
  reenviarDocumentacion,
  traeDocumentos,
  verificaDocumentacion,
  traeSemestreActual,
  registroEstancia,
  registroExternos,
  comprobanteInscripcion,
  verificaConstancia,
} from "../helpers/services";

export const getAllEstanciasAlumnos = async ({ commit }) => {
  const { data } = await getEstanciasAlum();

  if (Object.keys(data).length == 0) {
    // Modificar state a vacio, commit de una mutacion
    commit("listEstanciasAlum", []);
    return;
  }

  const { estancias } = data;
  commit("listEstanciasAlum", estancias);
  return estancias;
};

export const preRegistroAlumno = async (context, values) => {
  const { data } = await registroEstancia(values);
  return data;
};

export const registraExternos = async (context, values) => {
  const { data } = await registroExternos(values);
  return data;
};

export const subirArchivos = async (context, values) => {
  const { data } = await subirDocumentacion(values);
  return data;
};

export const resubirArchivos = async (context, values) => {
  const { data } = await reenviarDocumentacion(values);
  return data;
};

export const getDocumentacionRechazada = async ({ commit }) => {
  const { data } = await traeDocumentos();
  const { documentacion } = data;

  commit("traeDocumentos", documentacion);
};

export const verificaDocs = async ({ commit }) => {
  const { data } = await verificaDocumentacion();
  const { documentacion } = data;
  if (data.replyCode == 200) {
    if (documentacion.length > 0) {
      commit("verificaDocumentacion", documentacion);
      let rechazado = 0;
      let pendientes = 0;
      documentacion.forEach((documento) => {
        if (documento.estatus == "E") {
          pendientes += 1;
        } else if (documento.estatus == "R") {
          rechazado += 1;
        }
      });
      return rechazado !== 0 ? "R" : pendientes !== 0 ? "E" : "A";
    }
  }
  commit("verificaDocumentacion", documentacion);
  return data;
};

export const getSemestre = async ({ commit }) => {
  const { data } = await traeSemestreActual();

  const { semestre } = data;
  // Modificar el state, commit de una mutacion
  commit("traeSemestres", semestre);
  return semestre;
};

export const alumSubioDocs = async ({ commit }, values) => {
  commit("setSubioDocs", values);
};

export const mostrarMensaje = async ({ commit }, values) => {
  commit("setMensaje", values);
};

export const generarComprobante = async (context, values) => {
  const { data } = await comprobanteInscripcion(values);
  return data;
};

export const validaConstancia = async ({ commit }, values) => {
  const response = await verificaConstancia(values);
  if (response.replyCode === 200) {
    commit("setCosntancia", true);
  } else {
    commit("setCosntancia", false);
  }
};
